<template>
  <div>
    <div class="l-container">
      <p></p>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getTutors()
      vm.getOffices()
      vm.getPrefs()
      vm.getUsers()
      vm.getUser()
      vm.getChannels()
      vm.getOffice_channels()
    })
  },
  methods: {
    // getTutors: function () {
    //   this.$store.dispatch('getTutors')
    // },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    },

    getUsers () {
      this.$store.dispatch('getUsers')
    },

    getUser () {
      this.$store.dispatch('getUser')
    },

    getChannels () {
      this.$store.dispatch('getChannels')
    },

    getOffice_channels () {
      this.$store.dispatch('getOffice_channels')
    }
  },
  mounted () {
  }
}
</script>



// WEBPACK FOOTER //
// Tutors.vue?4105695c